/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

function FillAndSign({ mainColor, secondaryColor }) {
  return (
    <svg
      width="157"
      height="157"
      viewBox="0 0 157 157"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="78.5"
        cy="78.5"
        r="77.5"
        fill={mainColor}
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M119 107.947L100.211 126.736C99.4019 127.545 98.3042 128 97.1595 128H88.1579C86.9661 128 86 127.034 86 125.842V116.84C86 115.696 86.4547 114.598 87.2641 113.789L106.053 95L119 107.947Z"
        fill={secondaryColor}
      />
      <path
        d="M122.759 104L110 91.2409L113.995 87.2457C115.656 85.5848 118.349 85.5848 120.01 87.2457L126.754 93.9902C128.415 95.6511 128.415 98.344 126.754 100.005L122.759 104Z"
        fill={secondaryColor}
      />
      <path
        d="M96.8382 37H50.1618C43.9924 37 39 41.8614 39 47.869V109.131C39 115.139 43.9924 120 50.1618 120H80.1159L81.0088 115.139C81.4147 112.925 82.47 110.949 84.0935 109.329L108 86.0886V47.869C108 41.8614 103.008 37 96.8382 37ZM55.2353 52.8095H71.4706C73.7029 52.8095 75.5294 54.5881 75.5294 56.7619C75.5294 58.9357 73.7029 60.7143 71.4706 60.7143H55.2353C53.0029 60.7143 51.1765 58.9357 51.1765 56.7619C51.1765 54.5881 53.0029 52.8095 55.2353 52.8095ZM75.5294 92.3333H55.2353C53.0029 92.3333 51.1765 90.5548 51.1765 88.381C51.1765 86.2071 53.0029 84.4286 55.2353 84.4286H75.5294C77.7618 84.4286 79.5882 86.2071 79.5882 88.381C79.5882 90.5548 77.7618 92.3333 75.5294 92.3333ZM91.7647 76.5238H55.2353C53.0029 76.5238 51.1765 74.7452 51.1765 72.5714C51.1765 70.3976 53.0029 68.619 55.2353 68.619H91.7647C93.9971 68.619 95.8235 70.3976 95.8235 72.5714C95.8235 74.7452 93.9971 76.5238 91.7647 76.5238Z"
        fill={secondaryColor}
      />
    </svg>
  );
}

FillAndSign.propTypes = {
  mainColor: PropTypes.string,
  secondaryColor: PropTypes.string,
};
FillAndSign.defaultProps = {
  mainColor: '#7ED321',
  secondaryColor: '#FFFFFF',
};

const memoized = React.memo(FillAndSign);
memoized.displayName = 'FillAndSign';
export default memoized;
